import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArchiveFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.12 19.84V4.08H19.88V19.84H4.12ZM18.04 18V13.94H14.04C14.04 15.06 13.12 15.98 12 15.98C10.88 15.98 9.96 15.06 9.96 13.94H5.96V18H18.04Z" />
    </SvgIcon>
  );
});
